<div class="input-group" [class.input-focused]="isFocused()">
    @if (showLabel()) {
        <label for="typeahead-focus">{{ label() }}</label>
    }
    <input
        id="typeahead-focus"
        type="text"
        class="form-control font-sm no-border"
        [class.form-control-new]="isFocused()"
        [(ngModel)]="model"
        (ngModelChange)="modelChanged($event)"
        [ngbTypeahead]="search"
        (focus)="isFocused.set(true)"
        (blur)="isFocused.set(false)"
        #instance="ngbTypeahead"
        [placeholder]="placeholder()"
        (selectItem)="selectedItem($event)"
        [resultFormatter]="formatter"
    />
    <span class="input-group-text">
        <i class="fa-light fa-magnifying-glass"></i>
    </span>
</div>
